// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_0c9ca4', '__Roboto_Fallback_0c9ca4'","fontStyle":"normal"},"className":"__className_0c9ca4"};